import { useQuery as useTanstackQuery } from '@tanstack/react-query';
import { useSelector } from 'react-redux';

/**
 * Wrapper around TanStack's `useQuery` that automatically prepends
 * `currentWholesaler`, `currentPartner`, and `currentCompany` to the
 * `queryKey`, so queries refetch whenever the navigation context changes.
 *
 * @param {import('@tanstack/react-query').UseQueryOptions} options
 * @returns {import('@tanstack/react-query').UseQueryResult}
 */
export function useQuery({ queryKey, ...options }) {
    const { currentWholesaler, currentPartner, currentCompany } = useSelector(
        (state) => state.navigationLists,
    );

    return useTanstackQuery({
        queryKey: [...queryKey, currentWholesaler, currentPartner, currentCompany],
        ...options,
    });
}
